import { Box, CircularProgress, fade } from '@material-ui/core';

const Loading = () => {
  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      zIndex={99999}
      bgcolor={fade('#000000', 0.5)}
    >
      <CircularProgress size="large" style={{ width: 50, color: '#20d5b3 ' }} />
    </Box>
  );
};

export default Loading;
